import React from "react";
import * as MuiIcons from "@mui/icons-material";
import { MuiIconName } from "./MuiIconName"; // Arquivo com os nomes dos ícones

interface IconProps {
  iconName: MuiIconName; // Nome do ícone
  color?: string; // Cor do ícone (opcional)
  size?: number | string; // Tamanho do ícone (opcional)
}

export const IconRenderer: React.FC<IconProps> = ({
  iconName,
  color = "inherit",
  size = 24,
}) => {
  // Use uma verificação de tipo explícita para garantir segurança
  const IconComponent = MuiIcons[
    iconName as keyof typeof MuiIcons
  ] as React.ComponentType<React.SVGProps<SVGSVGElement>>;

  if (!IconComponent) {
    console.error(`Ícone "${iconName}" não encontrado.`);
    return null;
  }

  return <IconComponent style={{ color, fontSize: size }} />;
};
